import AgoraRTC from "agora-rtc-react";

const config = {
  mode: "live",
  codec: "vp8",
};

const usertcClient = AgoraRTC.createClient(config);

export default usertcClient;
